import { PrimitiveValueObjectDateTime } from '@/domain/primitiveValueObjectDateTime';

/**
 * 測定日時
 */
export class MeasureDateTime extends PrimitiveValueObjectDateTime {
  /**
   * 作成
   * @param value 値
   * @returns 値
   */
  static create(value: Date): MeasureDateTime {
    return new MeasureDateTime(value);
  }

  /**
   * ラベル
   */
  static get label(): string {
    return '測定日時';
  }

  /**
   * プレースホルダー
   */
  static get placeholder(): Date {
    return new Date('2022-01-01');
  }

  /**
   * バリデーションルール
   */
  static get validationRule() {
    return {
      /** 必須 */
      required: '必須項目です',
    };
  }
}
